// Utilities
import { createSimpleFunctional } from "../../util/index.mjs";
export const VCardText = createSimpleFunctional('v-card-text');
//# sourceMappingURL=VCardText.mjs.map